import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M24 10.667h-1.333V8A6.67 6.67 0 0 0 16 1.333 6.67 6.67 0 0 0 9.333 8v2.667H8a2.674 2.674 0 0 0-2.667 2.666v13.334c0 1.466 1.2 2.666 2.667 2.666h16c1.467 0 2.667-1.2 2.667-2.666V13.333c0-1.466-1.2-2.666-2.667-2.666m-8 12A2.674 2.674 0 0 1 13.333 20c0-1.467 1.2-2.667 2.667-2.667s2.667 1.2 2.667 2.667-1.2 2.667-2.667 2.667m4.133-12h-8.266V8A4.137 4.137 0 0 1 16 3.867 4.137 4.137 0 0 1 20.133 8z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }